import { create } from 'zustand';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const useAuthStore = create((set) => ({
  user: null,
  token: null,
  isAuthenticated: false,
  loading: true,
  authChecked: false,

  checkAuth: async () => {
    set({ loading: true });
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const response = await axios.post(`${API_BASE}/auth/verify`, {}, {
          headers: { Authorization: `Bearer ${token}` }
        });
        set({
          token,
          user: response.data.user,
          isAuthenticated: true,
          loading: false,
          authChecked: true
        });
      } catch (error) {
        localStorage.removeItem('token');
        set({ 
          token: null, 
          isAuthenticated: false,
          loading: false,
          authChecked: true
        });
      }
    } else {
      set({ 
        loading: false,
        authChecked: true
      });
    }
  },

  login: async (email, password) => {
    set({ loading: true });
    try {
      const response = await axios.post(`${API_BASE}/auth/login`, {
        email,
        password
      });
      const { user, token } = response.data;
      localStorage.setItem('token', token);
      set({
        user,
        token,
        isAuthenticated: true,
        loading: false
      });
      return { success: true };
    } catch (error) {
      set({ loading: false });
      throw error;
    }
  },

  register: async (email, password, fullName) => {
    set({ loading: true });
    try {
      const response = await axios.post(`${API_BASE}/auth/register`, {
        email,
        password,
        fullName
      });
      const { user, token } = response.data;
      localStorage.setItem('token', token);
      set({
        user,
        token,
        isAuthenticated: true,
        loading: false
      });
      return { success: true };
    } catch (error) {
      set({ loading: false });
      throw error;
    }
  },

  logout: () => {
    localStorage.removeItem('token');
    set({
      user: null,
      token: null,
      isAuthenticated: false
    });
  }
}));

export default useAuthStore;
